import React from "react";
import { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { Box, Button, Grid, Link, TableContainer, TextField } from "@mui/material";
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../cssPages/SelectEmail.css";
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Sella from "./Sella.png";
import axios from "axios";
import Url from "../services/Url";
import { useSharedStore } from "../services/SharedStore";


const SelezioneEmail = styled(RadioGroup)({
  textAlign: 'center'
});

const ElementoLista = styled(FormControlLabel)({
  fontFamily: 'Lato',
  fontSize: '15px',
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: '#4d606f',
  textAlign: 'center'
});

const ListaEmail = styled(FormControl)({
  textAlign: 'center'
});
const Informativa = styled(Box)({
  marginBottom: '36px',
  opacity: "0.5",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#333",
});
const SimpleBox = styled(Box)({
  textAlign: "center",
});
const Buttons = styled(Grid)({
  marginTop: '59px'
});
const HelperText = styled(Box)({
  marginTop: "168px",
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#919191",
});
const ContactLink = styled(Link)({
  fontFamily: "Lato",
  fontSize: "13px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.54",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#00cb4d",
});
const SelezionaEmail = styled(Box)({
  marginBottom: '38px',
  fontFamily: 'Lato',
  fontSize: '18px',
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: '0.13px',
  textAlign: 'center',
  color: '#4d606f'
});
const Intestazione = styled(Box)({
  fontFamily: "Montserrat, sans-serif",
  fontSize: "31px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "normal",
  textAlign: "center",
  color: "#1b1b1b",
});
const CompilaCampi = styled(Box)({
  fontFamily: "Lato",
  fontSize: "15px",
  fontWeight: "normal",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.11px",
  textAlign: "center",
  color: "#7b7b7b",
});
const UpButton = styled(Button)({
  "&:disabled": {
    backgroundColor: "#339aef",
    opacity: "0.5",
    color: "#fff",
  },
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#339aef",
  "&:hover": {
    backgroundColor: "#339aef",
  },
  "&:active": {
    backgroundColor: "#339aef",
  },
  "&:focus": {
    backgroundColor: "#339aef",
  },
});
const CloseButton = styled(Button)({
  borderRadius: "0px",
  height: "50px",
  boxShadow: "none",
  textTransform: "none",
  fontFamily: "Montserrat, sans-serif",
  fontSize: "12px",
  fontWeight: "600",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "normal",
  letterSpacing: "0.09px",
  textAlign: "center",
  color: "#fff",
  backgroundColor: "#4d606f",
  "&:hover": {
    backgroundColor: "#4d606f",
  },
  "&:active": {
    backgroundColor: "#4d606f",
  },
  "&:focus": {
    backgroundColor: "#4d606f",
  },
});

const Errors = styled(Box)({
  marginTop: "30px",
  fontFamily: "Lato",
  fontSize: "14px",
  fontWeight: "bold",
  fontStretch: "normal",
  fontStyle: "normal",
  lineHeight: "1.29",
  letterSpacing: "0.1px",
  color: "#f2662b",
  textAlign: "center"
});

function SelectEmail() {
  const [loading, setloading] = useState(false);
  const [emails, setEmails] = useState([]);
  const { addStore, getStore, getStoreAsync } = useSharedStore();
  const [value, setValue] = useState('');
  const [errMsg, setErrMsg] = useState('');

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const close = () => {
    history("/");
  }

  useEffect(() => {
    setloading(false);
    window.scrollTo(0, 0);
    getEmails();
  }, []);


  const getEmails = () => {
    setloading(true);
    getStoreAsync("token").then(val => {
      axios.get(Url + "api/getmail", {
        headers: {
          'Authorization': val
        }
      }).then(res => {
        setloading(false);
        if (res.data.response_code == "CR_1_30") {
          setEmails(res.data.response_data);
          setValue(res.data.response_data[0].id);
        }
      })
    })
  }



  const getSetEmail = () => {
    setloading(true);
    axios.get(Url + "api/setmail/" + value, {
      headers: {
        'Authorization': getStore("token")
      }
    }).then(res => {
      setloading(false);
      if (res.data.response_code == "CR_1_30b") {
        addStore("token", res.data.response_data);
        history("/OTP");
      } else {
        setErrMsg(res.data.response_desc);
      }
    })
  }

  const date = new Date();
  const currentYear = date.getFullYear();

  let state = false;
  let history = useNavigate();
  return (
    <Container maxWidth="xl">
      <Grid container>
        <Grid class="logoContainer" xs={12} sm={12} md={12}>
          <img class="logo" src={Sella}></img>
        </Grid>
      </Grid>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Intestazione>Recupera il tuo Codice Cliente o Username</Intestazione>
        </Grid>
      </Grid>
      <br></br>
      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <CompilaCampi>
            Compila i campi per recuperare il Codice Cliente o Username
          </CompilaCampi>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-8"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SelezionaEmail>
            Seleziona l’indirizzo email con cui desideri avviare la procedura di recupero codici:
          </SelezionaEmail>
        </Grid>
      </Grid>

      <Grid container spacing={5}>
        <Grid item xs={0} sm={0} md={4}></Grid>

        <Grid item xs={12} sm={12} md={4}>
          <SimpleBox>
            <ListaEmail>
              <SelezioneEmail value={value} onChange={handleChange}>
                {emails.map((option) => (
                  <FormControlLabel value={option.id} control={<Radio />} label={option.email} />
                ))}
              </SelezioneEmail>
            </ListaEmail>
          </SimpleBox>
        </Grid>
        <Grid item xs={0} sm={0} md={4}></Grid>
      </Grid>

      <Buttons container spacing={4}>
        <Grid item xs={0} sm={0} md={4}></Grid>
        <Grid item xs={12} sm={12} md={2}>
          <CloseButton
            onClick={close}
            disabled={loading}
            fullWidth
            variant="contained"
          >
            CHIUDI
          </CloseButton>
        </Grid>
        <Grid item xs={12} sm={12} md={2}>
          <UpButton
            fullWidth
            disabled={loading}
            variant="contained"
            onClick={getSetEmail}
          >
            PROSEGUI
          </UpButton>
        </Grid>
      </Buttons>


      <Errors dangerouslySetInnerHTML={{ __html: errMsg }}></Errors>


      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <HelperText>
            Vuoi maggiori informazioni o hai bisogno di assistenza?
          </HelperText>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <SimpleBox>
            <ContactLink href="/banca-on-line/contatti-e-assistenza">contatta il servizio clienti</ContactLink>
          </SimpleBox>
        </Grid>
      </Grid>

      <Grid container>
        <Grid item xs={0} sm={0} md={3}></Grid>
        <Grid item xs={12} sm={12} md={6}>
          <div class="Line-8"></div>
        </Grid>
        <Grid item xs={0} sm={0} md={3}></Grid>
      </Grid>

      <Grid container>
        <Grid item xs={12} sm={12} md={12}>
          <Informativa>
            © 1996-{currentYear} - Banca Sella S.p.A. - PI 02224410023 - Privacy
          </Informativa>
        </Grid>
      </Grid>
    </Container>


  );
}

export default SelectEmail;